import React from 'react'
import { useBasket } from '@sentecacommerce-theme/lib'
import { Config } from '../../../config'
import styled from 'styled-components'
import { IconClose } from '../Icons'

export const RemoveFromBasketButton = ({
  productId,
  variantId,
  lineItemId,
  close,
}: RemoveFromBasketButtonProps) => {
  const { removeFromBasket } = useBasket({
    productId,
    variantId,
    offerId: '',
  })

  const onClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault()
    if (close) close()
    removeFromBasket()
  }

  return (
    <Container onClick={onClick} type="button">
      <IconClose width="2rem" />
    </Container>
  )
}

type RemoveFromBasketButtonProps = {
  productId: string
  variantId: string
  lineItemId: string
  close?: () => void
}

const Container = styled.button`
  position: relative;
  min-height: 3rem;
  line-height: 0;
  border-radius: 50%;

  & svg {
    position: absolute;
    top: 0.4rem;
    right: 0.6rem;
    width: 1.2rem;
    height: 1.2rem;

    transition: transform 0.1s ease-out;
    &:hover {
      transform: scale(1.3);
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.md.min}) {
      top: 0.3rem;
      right: 0;
    }
  }
`
